import * as service from './service'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
export default {
  namespace: 'cashOut',
  state: {
    accountCash: {}
  },
  effects: {
    * getAccountCash ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getAccountCash, payload)
        const { data } = res
        if (data.code === 200) {
          yield put({
            type: 'save',
            payload: {
              accountCash: JSON.parse(data.data)
            }
          })
          return JSON.parse(data.data)
        } else {
          toast(data.errMsg || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * toWithDrawal ({ payload }, { call, put }) {
      try {
        const res = yield call(service.toWithDrawal, payload)
        const { data } = res
        if (data.code !== 200) {
          toast(data.errMsg || '发生网络错误')
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * helpBuyToWithDrawal ({ payload }, { call, put }) {
      try {
        const res = yield call(service.helpBuyToWithDrawal, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * queryWithdrawBankCard ({ payload }, { call, put }) {
      try {
        const res = yield call(service.queryWithdrawBankCard, payload)
        const { data } = res
        if (data.errMsg) {
          toast(data.errMsg)
        }
        return data
      } catch (error) {
        toast('发生网络错误')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
